import styled from "styled-components";
import { fromThemeProps } from "../../../helpers/utilities";
import media from "../../../helpers/media";

const StyledSection = styled.div`
  background: ${props => props.background || fromThemeProps("white")};
  display: flex;
  flex-direction: column;
  justify-content: ${props => props.jc || "center"};
  align-items: ${props => props.ai || "center"};

  ${media.xs`
    display: ${(props) => {
      if (props.hideDesktop) {
        return "none";
      }
    }}
  `}
`

export default StyledSection;


// WEBPACK FOOTER //
// ./src/styles/styledComponents/blocks/styledSection.js